<template>
  <div class="py-1 form-check">
    <input
      type="checkbox"
      class="checkbox form-check-input"
      :id="id"
      @change="updateCheckbox"
      :checked="props.isChecked"
      :disabled="props.disabled"
      data-testid="checkbox"
    />

    <label :for="props.id" class="form-check-label">{{ props.label }}</label>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  id: { type: String },
  label: { type: String },
  disabled: { type: Boolean, default: false },
  isChecked: { type: Boolean, default: false },
});

const emit = defineEmits(["onCheckboxClick"]);

const updateCheckbox = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("onCheckboxClick", target.checked);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

label {
  cursor: pointer;
  color: $pj-color-green;
}

.checkbox {
  box-shadow: none;
  outline: none;
  border-color: $pj-color-green;
  &:checked {
    background-color: $pj-color-green;
    color: $pj-color-green;
    outline: none;
    border: 0px;
    outline: none;
    box-shadow: none;
  }
}
</style>
